import { createContext, useContext } from 'react';

export const UserContext = createContext({ 
    userRole: '', 
    setUserRole: () => {}, 
    userId: '',
    setUserId: () => {},
    openModalDelete: '', 
    setOpenModalDelete: () => {},
    userInfos: {},
    setUserInfos: () => {},
    setOpenModalModifyUser: () => {},
    openModalModify: '',
    setUserModifyRole: () => '',
    userModifyRole: '', 
    userMediasList: [],
    setUserMediasList: () => [],
    openModalUserDocs: '',
    setOpenModalUserDocs: () => {}
});

export const useUserContext = () => {
    return useContext(UserContext);
};